"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveManager = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
const models_3 = require("./models");
const models_4 = require("./models");
const models_5 = require("./models");
class ActiveManager {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * Get active vehicles. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Array<ActiveVehicle>|net.NetError|number>}
    */
    getActiveVehiclesUnsafe(skip, take) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ActiveVehicles";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("skip=" + encodeURIComponent(skip));
            __query.push("take=" + encodeURIComponent(take));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.ActiveVehicle(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get active vehicles. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<ActiveVehicle>>}
    */
    getActiveVehicles(skip, take, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getActiveVehiclesUnsafe(skip, take);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Get full active vehicles. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Array<ActiveVehicleFull>|net.NetError|number>}
    */
    getActiveVehiclesFullUnsafe(skip, take) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/GetActiveVehiclesFull";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("skip=" + encodeURIComponent(skip));
            __query.push("take=" + encodeURIComponent(take));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_3.ActiveVehicleFull(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get full active vehicles. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<ActiveVehicleFull>>}
    */
    getActiveVehiclesFull(skip, take, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getActiveVehiclesFullUnsafe(skip, take);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Disable active vehicle.
    Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|net.NetError|number>}
    */
    disableActiveVehicleUnsafe(vehicleId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ActiveVehicle";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("vehicleId=" + encodeURIComponent(vehicleId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.DELETE, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Disable active vehicle.
    Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<number>}
    */
    disableActiveVehicle(vehicleId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.disableActiveVehicleUnsafe(vehicleId);
                if (typeof r !== "number")
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Get active orders. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Array<Order>|net.NetError|number>}
    */
    getActiveOrdersUnsafe(driverId, customerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ActiveOrders";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("driverId=" + encodeURIComponent(driverId));
            __query.push("customerId=" + encodeURIComponent(customerId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_4.Order(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get active orders. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<Order>>}
    */
    getActiveOrders(driverId, customerId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getActiveOrdersUnsafe(driverId, customerId);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Create a pre order for customer. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    createPreOrderForCustomerUnsafe(customerId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/PreOrderForCustomer";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("customerId=" + encodeURIComponent(customerId));
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Create a pre order for customer. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    createPreOrderForCustomer(customerId, body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.createPreOrderForCustomerUnsafe(customerId, body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Confirm the pre order. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    confirmOrderUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ConfirmPreOrder";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Confirm the pre order. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    confirmOrder(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.confirmOrderUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Take active order. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    takeActiveOrderForDriverUnsafe(driverId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/TakeActiveOrderForDriver";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("driverId=" + encodeURIComponent(driverId));
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Take active order. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    takeActiveOrderForDriver(driverId, body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.takeActiveOrderForDriverUnsafe(driverId, body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Cancel active order. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    cancelActiveOrderUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/CancelActiveOrder";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Cancel active order. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    cancelActiveOrder(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.cancelActiveOrderUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Untake active order for driver. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    untakeActiveOrderForDriverUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/UntakeActiveOrderForDriver";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Untake active order for driver. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    untakeActiveOrderForDriver(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.untakeActiveOrderForDriverUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Change active order state. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    changeActiveStateUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ChangeActiveState";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Change active order state. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    changeActiveState(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.changeActiveStateUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Complete active order and wait pay. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    completeActiveOrderAndWaitPayUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/CompleteActiveOrderAndWaitPay";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Complete active order and wait pay. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    completeActiveOrderAndWaitPay(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.completeActiveOrderAndWaitPayUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Change active order price. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    changeActiveOrderPriceUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ChangeActiveOrderPrice";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Change active order price. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    changeActiveOrderPrice(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.changeActiveOrderPriceUnsafe(body);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Get orders. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Array<OrderExtended>|net.NetError|number>}
    */
    byQueryUnsafe(fromTimeUTC, toTimeUTC, skip, take, driverId, customerId, onlyActive, onlyPast, state) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/ByQuery";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("fromTimeUTC=" + encodeURIComponent(fromTimeUTC));
            __query.push("toTimeUTC=" + encodeURIComponent(toTimeUTC));
            __query.push("skip=" + encodeURIComponent(skip));
            __query.push("take=" + encodeURIComponent(take));
            __query.push("driverId=" + encodeURIComponent(driverId));
            __query.push("customerId=" + encodeURIComponent(customerId));
            __query.push("onlyActive=" + encodeURIComponent(onlyActive));
            __query.push("onlyPast=" + encodeURIComponent(onlyPast));
            __query.push("state=" + encodeURIComponent(state));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_5.OrderExtended(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get orders. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<OrderExtended>>}
    */
    byQuery(fromTimeUTC, toTimeUTC, skip, take, driverId, customerId, onlyActive, onlyPast, state, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.byQueryUnsafe(fromTimeUTC, toTimeUTC, skip, take, driverId, customerId, onlyActive, onlyPast, state);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Get orders. Allowed:[ActiveControl]
    * @returns {Promise<ResultFail|Order|net.NetError|number>}
    */
    getOrderUnsafe(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/ActiveManager/Order";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("orderId=" + encodeURIComponent(orderId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_4.Order(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get orders. Allowed:[ActiveControl]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Order>}
    */
    getOrder(orderId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getOrderUnsafe(orderId);
                if (!(r instanceof models_4.Order))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.ActiveManager = ActiveManager;
//# sourceMappingURL=ActiveManager.js.map